import './CarouselCard.css';

const CarouselCard = ({ backgroundImage, label }) => {
	return (
		<div
			className='new-carousel-card'
			style={{
				background: `url(${backgroundImage})`,
			}}
		>
			<div className='new-carousel-card-label'>{label}</div>
		</div>
	);
};

export default CarouselCard;
